import { useSelector } from "react-redux";
import { selectUserType } from "../store/auth/index";

export const useUserType = () => {
  const userType = useSelector(selectUserType);
  return userType;
};
